import {
  InputProvider,
  groupInput,
  input,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const DHLCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  clientSecret: input<string>({ validator: nonEmptyValidator }),
  distributionCenter: input<string>({ validator: nonEmptyValidator }),
  pickupId: input<string>({ validator: nonEmptyValidator }),
});

export type DHLCarrierValue = InputProvider.Value<typeof DHLCarrierInput>;

export type DHLCarrierForm = InputProvider.Form<typeof DHLCarrierInput>;

export const dhlCarrierDefault = (): DHLCarrierValue => ({
  clientId: "",
  clientSecret: "",
  distributionCenter: "",
  pickupId: "",
});

export const CreateDHLCarrierForm = memo(function CreateDHLCarrierForm({
  carrierInput,
}: {
  carrierInput: DHLCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Client ID"
        placeholder=""
        setValue={carrierInput.inputs.clientId.setValue}
        value={carrierInput.inputs.clientId.value}
      />
      <RedoTextInput
        label="Client secret"
        placeholder=""
        setValue={carrierInput.inputs.clientSecret.setValue}
        value={carrierInput.inputs.clientSecret.value}
      />
      <RedoTextInput
        label="Distribution center"
        placeholder=""
        setValue={carrierInput.inputs.distributionCenter.setValue}
        value={carrierInput.inputs.distributionCenter.value}
      />
      <RedoTextInput
        label="Pickup ID"
        placeholder=""
        setValue={carrierInput.inputs.pickupId.setValue}
        value={carrierInput.inputs.pickupId.value}
      />
    </>
  );
});
